import { createCRUDHook } from './createCRUDHook';
import { HowToVideoDto } from 'utils/models';
import { EG_HOW_TO_VIDEO } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<HowToVideoDto>({
  entityName: 'HowToVideo',
  endpoint: EG_HOW_TO_VIDEO,
});

export const HowToVideoContext = Context;
export const useHowToVideoManager = useManager;
export const useHowToVideo = useConsumer;
